// extracted by mini-css-extract-plugin
export default {"colors":"Y3C2xk1jkY060LMUx5_D","wrapper":"Lx9cLCgODf8Md3wu6zek","text":"d8uWUdSKh8HpqzcAeADI","open":"Ttz2u8Guf4Tkw2zfPpXG"};